import React from "react";
import { Redirect } from "react-router-dom";
import { Shortcut } from "../../../../application/domain/ttzk-portal";
import { useAuthContextV2 } from "../../../../auth-state";
import Title from "../../../atoms/ttzk-portal/title";
import MainMenu from "./main-menu";
import { ShortcutsTable } from "./shortcuts-table";
import { TtzkPortalR } from "../../../pages/ttzk-portal/route";

type Props = {
  shortcuts: Shortcut[];
};

export const Content: React.FC<Props> = ({ shortcuts }) => {
  const { auth } = useAuthContextV2();
  const orgId = auth.data?.orgId;

  if (!auth.isPortalStandardPlan()) {
    return <Redirect to={TtzkPortalR.Home.link({})} />;
  }
  return (
    <>
      {auth.hasPermissions("ttzk_portal.shortcuts.list") && orgId && (
        <div>
          <Title text="ショートカット一覧" />
          <hr className="my-3" />
          <MainMenu />
          <ShortcutsTable shortcuts={shortcuts} />
        </div>
      )}
    </>
  );
};

export default Content;
